import React, { useEffect, useState } from "react";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { Colors } from "../../product/colors/Colors";
import { Hamburger } from "./Hamburger";
import logo from "./images/logo_color.svg";
import logoMobile from "./images/logo_color_mobile.svg";

const HamBurgerStyle = styled.div`
  display: none;
  @media (max-width: 900px) {
    display: block;
  }
`;
const Wrapper = styled.header`
  padding-top: 40px;
  width: fit-content;
  display: flex;
  align-items: center;
  width: 100%;
  height: 80px;
  color: white;
  font-weight: bold;
  padding-right: 30px;
  margin-bottom: 10px;

  @media (max-width: 1200px) {
    padding-inline: 5%;
  }

  @media (max-width: 800px) {
    padding-top: 20px;
    padding-inline: 40px;
  }
  @media (max-width: 600px) {
    padding-top: 0px;
    padding-inline: 10px;
  }
`;

const Flex = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  padding: 0 10%;

  @media (max-width: 1100px) {
    padding: 0;
  }
`;

const Flex2 = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 20px;
  margin-left: -50px;
`;

const LogoBox = styled.div`
  overflow: hidden;

  @media (max-width: 900px) {
    display: none;
  }
`;

const LogoMobileBox = styled.div`
  height: 80px;
  overflow: hidden;

  @media (min-width: 901px) {
    display: none;
  }
`;

const CustomLink = styled.a`
  color: ${Colors.accent1};
  cursor: pointer;
  position: relative;
  text-decoration: none;
  font-size: 16px;

  @media (min-width: 1390px) {
    color: ${(prev) =>
      ["product", "about"].includes(prev.type) ? "white" : Colors.accent1};
  }

  &:hover {
    border-bottom: 2px solid ${Colors.accent1};
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const CustomLinkButton = styled.div`
  display: flex;
  width: 170px;
  height: 43px;
  padding: 12px 18px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: ${Colors.accent2};
  color: ${Colors.white};
  cursor: pointer;
  position: relative;
  text-decoration: none;
  font-weight: 400;
  transition: 0.35s ease;
  padding: 10px;
  font-size: 16px;
  text-align: center;

  &:hover {
  }

  @media (max-width: 900px) {
    display: none;
  }
`;

const NewNavbar = ({ data }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { lang } = useParams();
  let locationElement = location.pathname.split("/")[2];
  const [addBorder, setAddBorder] = useState(locationElement);

  useEffect(() => {
    setAddBorder(locationElement);
  }, [addBorder, setAddBorder, locationElement, location, navigate]);

  return (
    <>
      <Wrapper>
        <Flex>
          <Link to="/">
            <LogoBox>
              <img
                src={logo}
                alt="logo"
                style={{
                  width: "100%",
                  height: "100%",
                  padding: "15px 10px",
                }}
              />
            </LogoBox>
            <LogoMobileBox>
              <img
                src={logoMobile}
                alt="logo"
                style={{
                  width: "auto",
                  height: "100%",
                  padding: "15px 10px",
                }}
              />
            </LogoMobileBox>
          </Link>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              gap: "30px",
              marginLeft: "40px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "30px",
              }}
            >
              <CustomLink
                className={addBorder === "about" ? "" : ""}
                onClick={() => navigate(`/${lang}/about`)}
              >
                {data[3].title}
              </CustomLink>
              <CustomLink
                className={addBorder === "product" ? "" : ""}
                onClick={() => navigate(`/${lang}/product`)}
              >
                KalbiGo
              </CustomLink>
              <CustomLink
                className={addBorder === "review" ? "" : ""}
                onClick={() => navigate(`/${lang}/review`)}
              >
                {data[4].title}
              </CustomLink>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "30px",
              }}
            >
              <CustomLink
                type={addBorder}
                className={addBorder === "course" ? "" : ""}
                onClick={() => navigate(`/${lang}/course`)}
              >
                {data[0].title}
              </CustomLink>
              <CustomLinkButton onClick={() => navigate(`/${lang}`)}>
                {data[1].title}
              </CustomLinkButton>
            </div>
          </div>
        </Flex>
        <Flex2>
          {/* <LanguageChanger /> */}
          <HamBurgerStyle>
            <Hamburger data={data} />
          </HamBurgerStyle>
        </Flex2>
      </Wrapper>
    </>
  );
};

export default NewNavbar;
